<template>
  <div class="header">
    <div class="main">
      <div @click="goHome()" class="logo">
        <img src="../assets/img/logo.png" />
        <span>{{ $t('main.KubuqiOfficialWebsite') }}</span>
      </div>
      <div class="nav-box">
        <!-- 导航菜单 -->
        <div class="navbar">
          <div
            :class="[navActive === index ? 'active' : '']"
            v-for="(item, index) in navbars"
            :key="index"
          >
            <span
              :class="[
                'flex-start',
                item == $t('main.secondTitle') || item == $t('main.pastGames')
                  ? 'nav-active'
                  : ''
              ]"
            >
              <span @click="clickNav(index)">
                {{ item }}
              </span>
              <!-- 第二届比赛 -->
              <i
                v-if="item == $t('main.secondTitle')"
                @click="handleChangShow(index)"
                :class="['el-icon-arrow-down', 'down-icon']"
              ></i>
              <!-- 过往比赛 -->
              <i
                v-if="item == $t('main.pastGames')"
                @click="handleChangShow1(index)"
                :class="['el-icon-arrow-down', 'down-icon']"
              ></i>
              <!-- 活动下拉菜单内容 -->
              <div
                v-if="item == $t('main.secondTitle')"
                :class="['nav-active-content', dateDot ? 'change-left' : '']"
                ref="activeRef"
                :style="`visibility:${visibility};opacity:${opacity};`"
              >
                <!-- :style="`visibility:${visibility};opacity:${opacity};left:${left}px`" -->
                <div class="nav-active-menu">
                  <div
                    @click="handleChangeActive(item)"
                    v-for="(item, index) in activeArr"
                    :key="index"
                    class="menuItem"
                  >
                    {{ item.label }}
                  </div>
                </div>
              </div>
              <!-- 过往比赛下拉内容 -->
              <div
                v-if="item == $t('main.pastGames')"
                class="nav-active-content past-contest"
                ref="pastGamesRef"
                :style="`visibility:${visibility1};opacity:${opacity1}`"
              >
                <div class="nav-active-menu">
                  <div
                    @click="handleChangeActive1(item)"
                    v-for="(item, index) in pastContestList"
                    :key="index"
                    class="menuItem"
                  >
                    {{ item.label }}
                  </div>
                </div>
              </div>
            </span>

            <span class="line"></span>
          </div>
        </div>
        <!-- 问卷调查 -->
        <div class="questionnaire">
          <span
            class="iconfont icon-wenjuan"
            @click="handleQuestionnaire"
          ></span>
          <!-- <div class="questionnaire-item">
            <div>问卷调查</div>
          </div> -->
        </div>
        <!-- 语言选择 -->
        <div class="language-change">
          <!-- 语言标题 -->
          <div class="language-change-title">
            <img src="../assets//svg/language.svg" alt="" />
            <span> {{ language }} </span>
          </div>
          <!-- 语言下拉菜单内容 -->
          <div class="language-change-content">
            <div class="language-change-menu">
              <div
                @click="changeLanguage(item)"
                v-for="(item, index) in languageArr"
                :key="index"
                class="menuItem"
              >
                {{ item.label }}
              </div>
            </div>
          </div>
        </div>
        <!-- 按钮 -->
        <div
          v-if="cookie"
          @click="clickNav(9)"
          class="personal-center"
          :class="[navActive === 8 ? 'active' : '']"
        >
          <span>{{ $t('main.personalCenter') }}</span>
          <span class="line"></span>
        </div>
        <div
          v-else
          :style="`width:${language === 'English' ? '140px' : ''}`"
          class="login-and-register"
          @click="clickNav(8)"
        >
          {{ this.$t('main.loginAndRegistration') }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCookie } from 'utils/cookie'
export default {
  name: 'PageHeader',
  data() {
    return {
      // 语言选择
      language: '简体中文',
      languageArr: [
        { label: '繁體中文', value: 'zhComplex', type: 'zh-hk' },
        { label: '简体中文', value: 'zhSimple', type: 'zh-cn' },
        { label: 'English', value: 'en', value: 'en-us' }
      ],
      activeArr: [
        { label: this.$t('main.active'), value: '1' },
        // { label: this.$t("main.AwardWinnersList"), value: "1" },
        { label: this.$t('main.topUniversity'), value: '2' }
      ],
      pastContestList: [
        { label: this.$t('main.firstCompetition'), value: '1' },
        { label: this.$t('main.firstCompetitionTwo'), value: '2' }
      ],
      // 导航名称列表
      navbars: [
        this.$t('main.homePage'),
        this.$t('main.backgroundOfTheCompetition'),
        this.$t('main.latestNews'),
        this.$t('main.secondTitle'),
        this.$t('main.pastGames'),
        this.$t('main.commonProblem'),
        this.$t('main.aboutUs'),
        this.$t('main.findUs')
      ],
      // 当前高亮的导航
      navActive: 0,
      // cookie
      cookie: '',
      isShowQuestion: true, // 是否显示问卷调查
      step: 0,
      step1: 0,
      visibility: 'hidden',
      visibility1: 'hidden',
      opacity: '0',
      opacity1: '0',
      show: false,
      day: '',
      left: 0,
      left1: 0,
      dateDot: false // 时间点: false:不显示中学组名单 | true: 显示中学组名单
    }
  },
  watch: {
    $route: {
      // 保存当前点击的页面
      handler(to, from) {
        this.getTime()
        // console.log("to", to);
        // 刷新页面时赋值当前路由对应的导航高亮
        let pathObj = {
          Home: 0,
          backgroundOfTheCompetition: 1,
          latestNews: 2,
          // secondCompetition: 3,
          previousCompetition: 4,
          commonProblem: 5,
          aboutUs: 6,
          findUs: 7,
          login: 8,
          personalCenter: 9
        }
        if (this.dateDot) {
          pathObj.secondCompetition = 3
        } else {
          pathObj['speak-sustainability-contest'] = 3
        }
        // 高亮
        if (to.meta && to.meta.activeMenu) {
          this.navActive = pathObj[to.meta.activeMenu]
        } else {
          this.navActive = pathObj[to.name]
        }
        if (to.name == 'secondCompetition' || to.name == 'finalists') {
          this.navActive = 3
        }
        if (
          to.name == 'speak-sustainability-contest' ||
          to.name == 'finalists'
        ) {
          this.navActive = 3
        }
        // 复制token
        this.cookie = getCookie('token') || ''
      },
      deep: true, // 深度监听
      immediate: true, // 第一次初始化渲染就可以监听到
      lang: ''
    }
  },
  created() {
    // 初始化展示语言 默认简体中文
    let lang = localStorage.getItem('lang') || 'zhComplex'
    this.lang = lang
    this.language = this.languageArr.find((x) => x.value === lang)?.label
  },
  mounted() {},
  methods: {
    // 时间
    getTime() {
      let currentDate = new Date()
      let expectedDate = new Date('2024-04-02T00:00:00')
      // let expectedDate = new Date("2024-03-29T17:05:00");
      if (currentDate < expectedDate) {
        // console.log("早");
        this.dateDot = false
        this.activeArr[0].label = this.$t('main.active')
      } else if (currentDate > expectedDate) {
        // console.log("晚");
        this.dateDot = true
        this.activeArr[0].label = this.$t('main.AwardWinnersList')
      }
    },
    // 点击
    handleClick() {
      window.addEventListener('click', function() {
        console.log('Hello World!')
      })
    },

    // 跳轉問卷調查
    handleQuestionnaire() {
      // console.log("問卷");
      const a = document.createElement('a')
      let href = null
      if (this.lang == 'zhSimple') {
        href = 'https://forms.gle/R2A92uQBfGn8kMx2A'
      } else if (this.lang == 'zhComplex') {
        href = 'https://forms.gle/ZFVEsULWiPJ9jEeE7'
      } else {
        href = 'https://forms.gle/ZKfHN8mPJkaHQ3636'
      }
      a.href = href
      a.target = '_blank'
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click()
    },

    // 点击logo跳转首页
    goHome() {
      this.$router.push({ name: 'Home' })
    },

    // 切换活动
    handleChangeActive({ label, value }) {
      switch (value) {
        case '1':
          if (
            window.navigator.userAgent.match(
              /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
            )
          ) {
            this.$router.push({ name: 'MobilePreviousCompetition' })
          } else {
            if (this.dateDot) {
              this.$router.push({ name: 'speak-sustainability-contest' })
            } else {
              this.$router.push({ name: 'secondCompetition' })
            }
          }
          // this.$router.push({ name: "awards" });
          this.visibility = 'hidden'
          this.opacity = '0'
          this.step++
          break
        case '2':
          this.$router.push({ name: 'finalists' })
          this.visibility = 'hidden'
          this.opacity = '0'
          this.step++
          break
      }
    },

    // 过往比赛 切换
    handleChangeActive1({ label, value }) {
      this.navActive = 4
      this.$router.push({ name: 'previousCompetition' })
      switch (value) {
        case '1':
          this.$router.push({ name: 'previousCompetition' })
          this.visibility1 = 'hidden'
          this.opacity1 = '0'
          this.step++
          break
        case '2':
          this.$router.push({ name: 'interestingSidelightsTwo' })
          this.visibility1 = 'hidden'
          this.opacity1 = '0'
          this.step++
          break
      }
    },

    // 切换语言
    changeLanguage({ label, value, type }) {
      this.language = label
      this.$i18n.locale = value
      // 同时保存本地 刷新页面
      localStorage.setItem('lang', value)
      localStorage.setItem('language', type)
      location.reload()
    },

    // 点击导航栏根据下标跳转页面
    clickNav(val) {
      // console.log("val: " + val);
      const hash = window.location.hash
      if (val == 3 && hash == 'secondCompetition') {
        return
      }
      if (val == 3 && hash == 'speak-sustainability-contest') {
        return
      }
      const pathObj = {
        0: 'Home',
        1: 'backgroundOfTheCompetition',
        2: 'latestNews',
        3: this.dateDot ? 'speak-sustainability-contest' : 'secondCompetition',
        4: 'previousCompetition',
        5: 'commonProblem',
        6: 'aboutUs',
        7: 'findUs',
        8: 'logIn',
        9: 'personalCenter'
      }
      this.navActive = val
      this.$router.push({ name: pathObj[val] })
    },

    //
    handleChangShow(val) {
      this.step1 = 0
      this.visibility1 = 'hidden'
      this.opacity1 = '0'
      if (val == 3 && this.step % 2 != 0) {
        this.visibility = 'hidden'
        this.opacity = '0'
        this.step++
        this.navActive = 3
        return
      } else if (val == 3 && this.step % 2 == 0) {
        this.visibility = 'visible'
        this.opacity = '1'
        this.step++
        this.navActive = 3
        return
      }
    },

    handleChangShow1(val) {
      this.step = 0
      this.visibility = 'hidden'
      this.opacity = '0'
      if (val == 4 && this.step1 % 2 != 0) {
        this.visibility1 = 'hidden'
        this.opacity1 = '0'
        this.step1++
        this.navActive = 4
        return
      } else if (val == 4 && this.step1 % 2 == 0) {
        this.visibility1 = 'visible'
        this.opacity1 = '1'
        this.step1++
        this.navActive = 4
        return
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  position: sticky;
  width: 100%;
  min-width: 1400px;
  top: 0;
  height: 80px;
  background: #000;
  color: #fff;
  z-index: 11;
  // min-width: 1000px;
  // overflow-x: scroll;

  &::-webkit-scrollbar {
    width: 0px;
    // width: 3px;
    height: 5px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: rgb(113, 113, 113);
  }

  &::-webkit-scrollbar-track {
    border-radius: 5px;
    background: transparent;
  }

  .main {
    width: 1400px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .logo {
    height: 80px;
    display: flex;
    align-items: center;
    cursor: pointer;

    img {
      width: 45px;
      height: 40px;
    }

    span {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      color: #ffffff;
      margin-left: 8px;
    }
  }

  .nav-box {
    display: flex;
    align-items: center;

    // line-height: 80px;
    .navbar {
      display: flex;
      align-items: center;
      margin-right: 164px;

      > div {
        // height: 26px;
        margin-left: 40px;
        font-size: 14px;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        // max-width: 84px;
        // max-width: 98px;

        span {
          line-height: 18px;
          display: inline-block;

          &:nth-child(1) {
            // text-align: left;
          }
        }

        .line {
          margin-top: 4px;
          display: inline-block;
          width: 28px;
          height: 2px;
          background: #000;
          border-radius: 1px;
        }
      }

      > div:hover {
        color: #00ffcd;

        .line {
          background: #00ffcd;
        }
      }

      .active {
        color: #00ffcd;

        .line {
          background: #00ffcd;
        }
      }
    }

    .language {
      position: relative;

      .language-all {
        position: absolute;
        width: 50px;
        text-align: center;
        left: -13px;
        background: #fff;
        border-radius: 5px;
      }
    }
  }
}

// 问卷调查
.questionnaire {
  position: relative;
  transition: all 0.6s ease-in-out;

  &:hover {
    cursor: pointer;
  }

  &:hover &-item {
    opacity: 1;
    visibility: visible;
  }

  &-item {
    width: 100px;
    height: 30px;
    background-color: rgba($color: #000, $alpha: 0.4);
    position: absolute;
    margin-top: 30px;
    border-radius: 4px;
    // bottom: -130px;
    margin-left: -45px;
    text-align: center;
    visibility: hidden; // 隐藏
    opacity: 0; // 隐藏

    &:hover {
      cursor: pointer;
      background-color: #00ffcd;
    }
  }
}

.nav-active {
  position: relative;

  .nav-active-content {
    // 定位显示区域
    position: absolute;
    left: -48px;
    // left: -18px;
    top: 56px;
    min-width: 160px;
    visibility: hidden; // 隐藏
    opacity: 0; // 隐藏
    transition: all 0.2s ease-in-out;

    .nav-active-menu {
      margin-top: 4px; // 与title制造距离
      color: white;
      background-color: rgba($color: #000, $alpha: 0.4);
      border-radius: 4px;

      .menuItem {
        width: 100%; // 自适应宽度
        white-space: nowrap;
        padding: 10px 16px;
        font-size: 16px;
        color: white;
        cursor: pointer;
        border-radius: 4px;

        &:hover {
          background-color: #00ffcd;
        }
      }
    }
  }

  // &:hover .nav-active-content {
  //   visibility: visible;
  //   opacity: 1;
  // }
  .change-left {
    left: -18px;
  }

  .past-contest {
    left: -46px;
  }
}

.down-icon {
  padding-left: 8px;
  line-height: 30px;
}

.flex-start {
  display: flex !important;
  justify-content: start;
  align-items: center;
}

// 语言选择
.language-change {
  margin-left: 20px;
  position: relative;
  top: -2px;
  display: flex;

  // z-index: 999;
  .language-change-title {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 12px;

    img {
      margin-right: 4px;
    }
  }

  .language-change-content {
    // 定位显示局域
    position: absolute;
    left: -12px;
    top: 50px;
    visibility: hidden; // 隐藏
    opacity: 0; // 隐藏
    transition: all 0.6s ease-in-out;

    .language-change-menu {
      margin-top: 4px; // 与title制造距离
      color: white;
      background-color: rgba($color: #000, $alpha: 0.4);
      border-radius: 4px;

      .menuItem {
        width: 100%; // 自适应宽度
        white-space: nowrap;
        padding: 10px 16px;
        font-size: 16px;
        color: white;
        cursor: pointer;
        border-radius: 4px;

        &:hover {
          background-color: #00ffcd;
        }
      }
    }
  }

  &:hover .language-change-content {
    visibility: visible;
    opacity: 1;
  }
}

.login-and-register {
  border: 1px solid #fff;
  height: 34px;
  padding: 0 16px;
  line-height: 34px;
  border-radius: 3px;
  margin-left: 30px;
  font-size: 14px;
  color: #fff;
  cursor: pointer;

  &:hover {
    border-color: #00ffcd;
    color: #00ffcd;
  }
}

.personal-center {
  margin-left: 30px;
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  text-align: center;

  .line {
    margin-top: 4px;
    display: inline-block;
    width: 28px;
    height: 2px;
    background: #000;
    border-radius: 1px;
  }

  &:hover {
    color: #00ffcd;

    .line {
      background: #00ffcd;
    }
  }

  &.active {
    color: #00ffcd;

    .line {
      background: #00ffcd;
    }
  }
}
</style>
